<template>
    <div id="profile-page">

        <!-- PROFILE HEADER -->
        <div class="profile-header">
            <div class="relative">
                <div class="cover-container rounded-t-lg">
                    <img :src="cover_img" alt="user-profile-cover" class="responsive block">
                </div>
                <div class="profile-img-container pointer-events-none">
                    <div class="block mt-20">
                        <vs-avatar class="user-profile-img" :src="user.avatarUrl" size="200px" />
                    </div>
                    <div class="text-white text-3xl">
                      {{user.nickName || user.userName}}
                    </div>
                    <div class="profile-actions pointer-events-auto block mt-10">
                      <div class="">
                        <!-- <vs-button  icon-pack="feather" radius icon="icon-edit-2" class="inline-block"></vs-button> -->
                        <vs-button to="/pages/setting" icon-pack="feather" radius icon="icon-settings" class="ml-2 lg:ml-4 inline-block"></vs-button>
                      </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- COL AREA -->
        <div class="vx-row">
            <!-- COL 1 -->
            <div class="vx-col w-full lg:w-1/4">
                <!-- ABOUT CARD -->
                <vx-card title="个人资料" class="mt-base">
                    <!-- ACTION SLOT -->
                    <template slot="actions">
                        <icon icon="MoreHorizontalIcon"></icon>
                    </template>

                    <!-- USER BIO -->
                    <div class="user-bio">
                        <p>{{user.description}}</p>
                    </div>

                    <!-- OTEHR DATA -->
                    <div class="mt-5">
                        <h6>用户ID:</h6>
                        <p>{{user.uid}}</p>
                    </div>

                    <div class="mt-5" v-if="user.nickName">
                        <h6>昵称:</h6>
                        <p>{{user.nickName}}</p>
                    </div>

                    <div class="mt-5">
                        <h6>用户名:</h6>
                        <p>{{user.userName}}</p>
                    </div>

                    <div class="mt-5">
                        <h6>性别:</h6>
                        <p>{{user.sex}}</p>
                    </div>

                    <div class="mt-5" v-if="user.email">
                        <h6>Email:</h6>
                        <p>{{user.email}}</p>
                    </div>

                    <div class="mt-5" v-if="user.phone">
                        <h6>手机号:</h6>
                        <p>{{user.phone}}</p>
                    </div>

                    <div class="mt-5" v-if="user.birthday">
                        <h6>生日:</h6>
                        <p>{{user.birthday | date}}</p>
                    </div>

                    <div class="mt-5">
                        <h6>地址:</h6>
                        <p>{{user.country}} {{user.province}} {{user.city}} {{user.address}}</p>
                    </div>


                    <div class="social-links flex mt-4">
                        <icon svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded" class="mr-2" icon="FacebookIcon"></icon>
                        <icon svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded" class="mr-2" icon="TwitterIcon"></icon>
                        <icon svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded" class="mr-2" icon="InstagramIcon"></icon>
                    </div>
                </vx-card>
            </div>

            <!-- COL 2 -->
            <div class="vx-col w-full lg:w-3/4">
                <vx-card class="mt-base">
                    
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  data() {
    return {
      isNavOpen: false,
      userPoll: '',
    
      cover_img: require("@/assets/images/pages/profile-cover.jpg"),
    }
  },
  $computed: ['auth.user'],
  methods: {

  },
  mounted() {
    
  },
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";
</style>
